/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StreamEmbedResponse
 */
export interface StreamEmbedResponse {
    /**
     * 
     * @type {string}
     * @memberof StreamEmbedResponse
     */
    embedUrl: string;
    /**
     * 
     * @type {string}
     * @memberof StreamEmbedResponse
     */
    chatEmbedUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof StreamEmbedResponse
     */
    width: number;
    /**
     * 
     * @type {number}
     * @memberof StreamEmbedResponse
     */
    height: number;
    /**
     * 
     * @type {string}
     * @memberof StreamEmbedResponse
     */
    channelUrl?: string;
}

/**
 * Check if a given object implements the StreamEmbedResponse interface.
 */
export function instanceOfStreamEmbedResponse(value: object): value is StreamEmbedResponse {
    if (!('embedUrl' in value) || value['embedUrl'] === undefined) return false;
    if (!('width' in value) || value['width'] === undefined) return false;
    if (!('height' in value) || value['height'] === undefined) return false;
    return true;
}

export function StreamEmbedResponseFromJSON(json: any): StreamEmbedResponse {
    return StreamEmbedResponseFromJSONTyped(json, false);
}

export function StreamEmbedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StreamEmbedResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'embedUrl': json['embedUrl'],
        'chatEmbedUrl': json['chatEmbedUrl'] == null ? undefined : json['chatEmbedUrl'],
        'width': json['width'],
        'height': json['height'],
        'channelUrl': json['channelUrl'] == null ? undefined : json['channelUrl'],
    };
}

export function StreamEmbedResponseToJSON(json: any): StreamEmbedResponse {
    return StreamEmbedResponseToJSONTyped(json, false);
}

export function StreamEmbedResponseToJSONTyped(value?: StreamEmbedResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'embedUrl': value['embedUrl'],
        'chatEmbedUrl': value['chatEmbedUrl'],
        'width': value['width'],
        'height': value['height'],
        'channelUrl': value['channelUrl'],
    };
}

